export default {
  LG: 'lg',
  SM: 'sm'
}
